import { render, staticRenderFns } from "./VendasPerdidas.vue?vue&type=template&id=33f22c36&"
import script from "./VendasPerdidas.vue?vue&type=script&lang=js&"
export * from "./VendasPerdidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f22c36')) {
      api.createRecord('33f22c36', component.options)
    } else {
      api.reload('33f22c36', component.options)
    }
    module.hot.accept("./VendasPerdidas.vue?vue&type=template&id=33f22c36&", function () {
      api.rerender('33f22c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VendasPerdidas.vue"
export default component.exports